<script>
    export let records = [];
  </script>
  
  <div class="record-grid">
    {#each records as rec}
      <div class="record-box">
        <h3 class="record-title">{rec.title}</h3>
        <img
          class="record-photo"
          src={rec.profilepic}
          alt="User Picture"
        />
        <p>Name: {rec.displayName}</p>
        <p>Referral Code: {rec.referralCode}</p>
        <br />
        <p>{rec.recordNumber}</p>
      </div>
    {/each}
  </div>
  
  <style>
    .record-grid {
      display: flex;
      flex-wrap: wrap;
      gap: 1.5rem;
      max-width: 1200px;
      margin: 2rem auto;
      justify-content: flex-start;
    }
    .record-box {
      flex: 1 1 calc(25% - 1.5rem);
      background: #1a1c22;
      border: 1px solid #424867;
      border-radius: 8px;
      text-align: center;
      padding: 1rem;
      box-sizing: border-box;
      min-width: 180px;
    }
    .record-title {
      margin: 0 0 0.75rem;
      font-size: 1.1rem;
      font-weight: bold;
      color: #e2e8f0;
    }
    .record-photo {
      width: 80px;
      height: 80px;
      border-radius: 50%;
      object-fit: cover;
      border: 2px solid #424867;
      margin-bottom: 0.5rem;
    }
    .record-photo:hover {
      border-color: #646cff;
    }
    .record-box p {
      margin: 0.25rem 0;
      font-size: 0.9rem;
      color: #ccc;
    }
    @media (max-width: 900px) {
      .record-box {
        flex: 1 1 calc(50% - 1.5rem);
      }
    }
    @media (max-width: 500px) {
      .record-box {
        flex: 1 1 100%;
      }
    }
  </style>
  